import { useCallback } from "react";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../externalComponents/tailwind/dialog";

const DialogArchive = ({
  customerId,
  listData,
  setListData,
  mappingAutomationTypeWithField,
}) => {
  const { selectedCampaign, isModalOpen, isArchiveLoading } = listData;

  const updateIsArchiveLoading = useCallback((isArchiveLoading) => {
    setListData((_listData) => ({
      ..._listData,
      isArchiveLoading,
    }));
  }, []);

  const closeModal = useCallback(() => {
    setListData((_listData) => ({
      ..._listData,
      isModalOpen: false,
    }));
  }, []);

  const handleArchiveConfirmation = async () => {
    updateIsArchiveLoading(true);

    if (listData.selectedCampaign) {
      if (
        !["api", "klaviyo", "splio", "batch"].includes(
          listData.selectedCampaign.automationType,
        )
      ) {
        await api.customer.update(customerId, {
          [mappingAutomationTypeWithField[
            listData.selectedCampaign.automationType
          ]]: null,
        });
      }

      await api.campaign.update(listData.selectedCampaign.id, {
        isArchived: true,
      });
    }

    setListData((_listData) => ({
      ..._listData,
      isModalOpen: false,
      isArchiveLoading: false,
    }));
  };

  return (
    <Dialog
      key="dialog_archive"
      open={isModalOpen}
      onClose={() => closeModal()}
    >
      <DialogTitle>Archive this automation </DialogTitle>
      <DialogBody className="flex-1 overflow-y-auto scrollbar">
        <p>
          Are you sure you want to archive the automation{" "}
          <b>{selectedCampaign?.name}</b>?
        </p>
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          onClick={() => closeModal()}
          disabled={isArchiveLoading}
          className="min-w-[100px] h-10"
        >
          Cancel
        </Button>
        <Button
          color="primaryButton"
          onClick={() => handleArchiveConfirmation(selectedCampaign)}
          className="min-w-[100px] h-10"
          loading={isArchiveLoading}
        >
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogArchive;
